// frontend/src/pages/Connect/index.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const PHASE_LABEL = {
  starting: "⏳ Iniciando…",
  opening: "🌐 Abrindo o WhatsApp Web…",
  waiting: "📲 Faça o login no WhatsApp Web (QR, código ou passkey)…",
  capturing: "🔑 Login detectado — capturando a sessão…",
  sending: "📤 Enviando a sessão ao servidor…",
  connecting: "🔌 Conectando a instância…",
  wiping: "🧹 Finalizando…",
  done: "✅ Conectado! Fechando esta aba…",
  error: "⚠️ Erro"
};

const Connect = () => {
  const { token } = useParams();
  const [extReady, setExtReady] = useState(false);
  const [status, setStatus] = useState(null); // { phase, detail }

  useEffect(() => {
    let done = false;
    const onMsg = (e) => {
      if (e.source !== window) return;
      const d = e.data || {};
      if (d.type === "CONECTOR_EXT_READY" || d.type === "CONECTOR_PONG") {
        done = true;
        setExtReady(true);
      }
      if (d.source === "conector" && d.type === "CONECTOR_STATUS") {
        done = true;
        setExtReady(true);
        setStatus({ phase: d.phase, detail: d.detail });
      }
    };
    window.addEventListener("message", onMsg);
    const ping = () => window.postMessage({ type: "CONECTOR_PING" }, "*");
    ping();
    const iv = setInterval(() => {
      if (done) clearInterval(iv);
      else ping();
    }, 500);
    const stop = setTimeout(() => clearInterval(iv), 6000);
    return () => {
      window.removeEventListener("message", onMsg);
      clearInterval(iv);
      clearTimeout(stop);
    };
  }, [token]);

  // Ao concluir, fecha a aba sozinha (aberta via window.open, então window.close funciona).
  useEffect(() => {
    if (status && status.phase === "done") {
      const t = setTimeout(() => {
        try {
          window.close();
        } catch (e) {
          /* alguns navegadores bloqueiam; a mensagem de fallback continua visível */
        }
      }, 2500);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [status]);

  return (
    <div style={{ maxWidth: 560, margin: "40px auto", fontFamily: "sans-serif", padding: 16 }}>
      <h2>Conectar via WhatsApp Web</h2>

      {!extReady && (
        <p>⚠️ Extensão não detectada. Instale a extensão Conector e recarregue esta página.</p>
      )}

      {extReady && !status && (
        <p>✅ Extensão detectada. Abrindo o WhatsApp Web… uma aba vai abrir para você fazer o login.</p>
      )}

      {status && (
        <div>
          <p style={{ fontSize: 16, fontWeight: 600 }}>
            {PHASE_LABEL[status.phase] || status.phase}
          </p>
          {status.detail && status.phase !== "error" && (
            <p style={{ color: "#555" }}>{status.detail}</p>
          )}
          {status.phase === "error" && (
            <p style={{ color: "#c0392b" }}>{status.detail}</p>
          )}
          {status.phase === "waiting" && (
            <p style={{ color: "#888", fontSize: 13 }}>
              Assim que você conectar no WhatsApp Web, a sessão é movida automaticamente
              e a aba fecha sozinha. Não é preciso clicar na extensão.
            </p>
          )}
        </div>
      )}

      <p style={{ color: "#aaa", fontSize: 12, marginTop: 24 }}>Token: {token}</p>
    </div>
  );
};

export default Connect;
